(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahc-readiness"] && !Shopify.designMode) return;
  try {
    
const VERSION = "Beta v1.0";
const EVENTS = [
    { key: "swim", title: "500m swim", short: "Swim", max: 400, weight: 40, baseline: "10:00", protocol: "Swim 500 meters continuously without fins or propulsion equipment. Use a measured 25m or 50m pool for comparable results. Record open-water conditions separately. Use a lifeguarded swimming location." },
    { key: "sprint", title: "50m sprint", short: "Sprint", max: 200, weight: 20, baseline: "8.00 sec", protocol: "Use an accurately measured 50m course on flat, firm ground. Start standing and stationary, with the front foot behind the line. Start timing on the signal and stop when the torso crosses the finish. No starting blocks. Record the timing method." },
    { key: "run", title: "1.5-mile run", short: "Run", max: 150, weight: 15, baseline: "12:00", protocol: "Run 1.5 miles (2,414m) continuously on a measured, flat course. Six laps of a 400m track is short of 1.5 miles; include the remaining distance. Use a standing start and avoid net downhill routes." },
    { key: "carry", title: "100m sandbag carry", short: "Carry", max: 150, weight: 15, baseline: "65 sec", protocol: "Use a 75-lb sandbag over 100 meters. Start with the bag fully on the ground behind the line. Carry in a front bear hug. Resting and putting the bag down are allowed while the clock continues. Stop when the athlete and entire bag cross the finish. No shoulder carry, dragging, or throwing." },
    { key: "pull", title: "Pulling capacity", short: "Pull", max: 100, weight: 10, baseline: "5 pull-ups / 15 rows", protocol: "Pull-ups: overhand grip, full dead hang, chin above the bar, controlled repetitions, no kipping or leg drive. Ring rows: approximately 45° at the bottom, fixed heels, straight knees and hips, full arm extension, chest to rings, no hip thrust. Record the method; equivalence is provisional." },
];
const TIMED = {
    swim: [[420, 100], [465, 90], [510, 80], [555, 70], [600, 60], [660, 30], [720, 0]],
    sprint: [[6.5, 100], [6.88, 90], [7.25, 80], [7.63, 70], [8, 60], [9, 30], [10, 0]],
    run: [[540, 100], [585, 90], [630, 80], [675, 70], [720, 60], [810, 30], [900, 0]],
    carry: [[35, 100], [42.5, 90], [50, 80], [57.5, 70], [65, 60], [92, 30], [120, 0]],
};
const PULL_UP_SCORES = [0, 15, 25, 35, 47.5, 60, 63.3, 66.7, 70, 75, 80, 83.3, 86.7, 90, 95, 100];
const ROW_SCORES = [0, 3.75, 7.5, 11.25, 15, 18.75, 22.5, 26.25, 30, 34.3, 38.6, 42.9, 47.1, 51.4, 55.7, 60, 62.5, 65, 67.5, 70, 72.5, 75, 77.5, 80, 83.3, 86.7, 90, 92.5, 95, 97.5, 100];
const BASELINES = { swim: 600, sprint: 8, run: 720, carry: 65 };
const round = (n, digits = 0) => Math.round((n + Number.EPSILON) * 10 ** digits) / 10 ** digits;
function timedScore(key, seconds) {
    const a = TIMED[key];
    if (seconds <= a[0][0])
        return 100;
    if (seconds >= a[a.length - 1][0])
        return 0;
    for (let i = 1; i < a.length; i++) {
        const [x, y] = a[i], [px, py] = a[i - 1];
        if (seconds <= x)
            return round(py + (y - py) * (seconds - px) / (x - px), 1);
    }
    return 0;
}
function eventResult(key, value, method = "Pull-ups") {
    if (!Number.isFinite(value) || (key === "pull" ? value < 0 || !Number.isInteger(value) : value <= 0))
        throw new Error("Enter a valid result.");
    const table = method === "Pull-ups" ? PULL_UP_SCORES : ROW_SCORES;
    const score = key === "pull" ? table[Math.min(value, table.length - 1)] : timedScore(key, value);
    const max = EVENTS.find(e => e.key === key).max;
    return { score, points: round(score * max / 100), baselineMet: key === "pull" ? value >= (method === "Pull-ups" ? 5 : 15) : value <= BASELINES[key] };
}
function classification(total) { return total >= 900 ? "Elite" : total >= 800 ? "Advanced" : total >= 700 ? "Strong" : total >= 600 ? "Patrol Baseline" : total >= 500 ? "Developing" : "Foundation"; }
function calculate(raw) {
    if (!["Pull-ups", "45° Ring Rows"].includes(raw.pullMethod))
        throw new Error("Choose a pulling method.");
    const events = Object.fromEntries(EVENTS.map(e => [e.key, eventResult(e.key, raw[e.key], raw.pullMethod)]));
    const total = Object.values(events).reduce((n, e) => n + e.points, 0);
    return { total, classification: classification(total), coreMet: raw.swim <= 600 && raw.run <= 720, events };
}
function formatTime(seconds) { const m = Math.floor(seconds / 60), s = round(seconds - m * 60, 2); return m + ":" + (s < 10 ? "0" : "") + s; }
function formatRaw(key, value) { return key === "swim" || key === "run" ? formatTime(value) : key === "pull" ? value + " reps" : value + " sec"; }

function csvCell(value) {
  let text = String(value ?? "");
  if (/^[\s\uFEFF]*[=+@-]/.test(text)) text = "'" + text;
  return '"' + text.replaceAll('"', '""') + '"';
}
function validDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(value + "T12:00:00Z");
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
class AHCReadiness extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.copy = JSON.parse(this.querySelector("[data-copy]").textContent);
    this.form = this.querySelector("form");
    this.resultPanel = this.querySelector(".ahc-lrs__result");
    this.download = this.querySelector("[data-download]");
    this.status = this.querySelector("[data-status]");
    const today = new Date();
    this.form.elements.testDate.value = [today.getFullYear(), String(today.getMonth()+1).padStart(2,"0"), String(today.getDate()).padStart(2,"0")].join("-");
    const breakdown = this.querySelector("[data-breakdown]");
    for (const event of EVENTS) {
      this.querySelector(`[data-protocol="${event.key}"]`).textContent = this.tr("protocol_" + event.key);
      const row = document.createElement("div");
      row.className = "ahc-lrs__event-result";
      row.innerHTML = `<div class="ahc-lrs__event-label"><span data-label></span><strong data-points="${event.key}">— / ${event.max}</strong></div><div class="ahc-lrs__bar" aria-hidden="true"><span data-bar="${event.key}" style="width:0%"></span></div>`;
      row.querySelector('[data-label]').textContent = this.tr(event.key);
      breakdown.append(row);
    }
    this.form.addEventListener("input", () => this.update());
    this.form.addEventListener("change", () => this.update());
    this.form.addEventListener("submit", event => {
      event.preventDefault();
      this.update();
      if (!this.form.reportValidity() || !this.current) return;
      this.resultPanel.focus({preventScroll:true});
      this.resultPanel.scrollIntoView({behavior:"auto",block:"start"});
      this.status.textContent = this.tr("calculated", {total:this.current.total, classification:this.classLabel(this.current.classification)});
    });
    this.download.addEventListener("click", () => this.export());
    this.accounts = this.querySelector('[data-accounts]');
    this.saveButton = this.querySelector('[data-save]');
    this.saveStatus = this.querySelector('[data-save-status]');
    this.historyArea = this.querySelector('[data-history]');
    this.moreButton = this.querySelector('[data-more]');
    this.requestIds = new Map(); this.savedItems = []; this.csrf = null; this.saving = false;
    this.accounts.hidden = this.dataset.savingEnabled !== 'true';
    this.querySelector('[data-login]').href = this.dataset.loginUrl;
    this.saveButton.addEventListener('click', () => this.saveToAccount());
    this.querySelector('[data-refresh]').addEventListener('click', () => this.loadSaved());
    this.moreButton.addEventListener('click', () => this.loadSaved(true));
    this.update();
    if (!this.accounts.hidden) this.loadSaved();
  }
  tr(key, vars = {}) {
    let value = this.copy[key] ?? key;
    for (const [name, replacement] of Object.entries(vars)) value = value.split("__" + name + "__").join(String(replacement));
    return value;
  }
  classLabel(value) { return this.tr("classification_" + value.toLowerCase().replaceAll(" ","_")); }
  field(name) { return this.form.elements.namedItem(name); }
  text(name) { return this.field(name).value.trim(); }
  numeric(name) {
    const field = this.field(name);
    return field.value !== "" && field.validity.valid ? field.valueAsNumber : null;
  }
  duration(name) {
    const minutes = this.numeric(name + "Minutes");
    const seconds = this.numeric(name + "Seconds");
    return minutes !== null && seconds !== null && minutes*60+seconds > 0 ? minutes*60+seconds : null;
  }
  update() {
    this.status.textContent = "";
    this.field("testDate").setCustomValidity("");
    if (!validDate(this.text("testDate"))) this.field("testDate").setCustomValidity(this.tr("invalid_date"));
    for (const key of ["swim", "run"]) {
      this.field(key+"Seconds").setCustomValidity("");
      if (this.numeric(key+"Minutes") === 0 && this.numeric(key+"Seconds") === 0) this.field(key+"Seconds").setCustomValidity(this.tr("invalid_time"));
    }
    const raw = {swim:this.duration("swim"), sprint:this.numeric("sprint"), run:this.duration("run"), carry:this.numeric("carry"), pull:this.numeric("pull"), pullMethod:this.text("pullMethod")};
    this.raw = raw;
    for (const event of EVENTS) {
      const result = raw[event.key] === null ? null : eventResult(event.key, raw[event.key], raw.pullMethod);
      this.querySelector(`[data-points="${event.key}"]`).textContent = `${result ? result.points : "—"} / ${event.max}`;
      this.querySelector(`[data-bar="${event.key}"]`).style.width = `${result ? result.score : 0}%`;
    }
    this.current = EVENTS.every(event => raw[event.key] !== null) ? calculate(raw) : null;
    this.querySelector("[data-total]").textContent = this.current ? this.current.total : "—";
    this.querySelector("[data-classification]").textContent = this.current ? this.classLabel(this.current.classification) : this.tr("incomplete");
    for (const [key, threshold] of [["swim",600],["run",720]]) this.querySelector(`[data-${key}-gate]`).textContent = this.tr("gate_format", {label:this.tr("gate_"+key),status:this.tr(raw[key] === null ? "awaiting" : raw[key] <= threshold ? "met" : "not_met")});
    this.querySelector("[data-core-status]").textContent = raw.swim === null || raw.run === null ? this.tr("core_pending") : raw.swim <= 600 && raw.run <= 720 ? this.tr("core_met") : this.tr("core_not_met");
    this.querySelector("[data-pull-baseline]").textContent = raw.pullMethod === "Pull-ups" ? this.tr("baseline_pullups") : this.tr("baseline_rows");
    this.querySelector("[data-comparability]").textContent = this.text("swimSetting") === "Open water" ? this.tr("open_water") : this.tr("comparison");
    this.download.disabled = !this.current || !this.form.checkValidity();
    if (this.saveButton) this.saveButton.disabled = !this.current || !this.csrf || this.saving || !this.form.checkValidity() || this.savedFingerprint === this.fingerprint();
  }
  apiUrl(offset = 0) {
    const url = new URL(this.dataset.api, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/apps/')) throw new Error(this.tr('saving_unavailable'));
    url.searchParams.set('offset', String(offset));
    return url;
  }
  payload() {
    return {athleteName:this.text('athleteName') || this.tr('self_assessment'),patrol:this.text('patrol'),testDate:this.text('testDate'),swimSetting:this.text('swimSetting'),sprintTiming:this.text('sprintTiming'),notes:this.text('notes'),...this.raw};
  }
  fingerprint() { return this.current ? JSON.stringify(this.payload()) : ''; }
  async loadSaved(append = false) {
    if (this.accounts.hidden || this.loadingHistory) return;
    this.loadingHistory = true; this.moreButton.disabled = true;
    this.saveStatus.textContent = this.tr('loading_saved');
    try {
      const response = await fetch(this.apiUrl(append ? this.savedItems.length : 0), {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
      if (response.status === 401) {
        this.csrf = null; this.savedFingerprint = null; this.savedItems = []; this.historyArea.replaceChildren(); this.moreButton.hidden = true;
        this.querySelector('[data-login-prompt]').hidden = false;
        this.saveStatus.textContent = this.tr('sign_in_to_save');
        return;
      }
      const result = await response.json();
      if (!response.ok || !Array.isArray(result.items) || typeof result.csrfToken !== 'string') throw new Error(result.error || this.tr('saving_unavailable'));
      this.csrf = result.csrfToken;
      this.savedItems = append ? [...this.savedItems,...result.items] : result.items;
      this.querySelector('[data-login-prompt]').hidden = true;
      this.renderHistory(); this.moreButton.hidden = this.savedItems.length >= result.total;
      this.saveStatus.textContent = result.total ? this.tr('saved_count',{count:result.total}) : this.tr('no_saved_results');
    } catch(error) {
      this.csrf = null;
      this.saveStatus.textContent = this.tr('saving_unavailable');
    } finally {
      this.loadingHistory = false; this.moreButton.disabled = false;
      this.saveButton.disabled = !this.current || !this.csrf || this.saving || !this.form.checkValidity() || this.savedFingerprint === this.fingerprint();
    }
  }
  async saveToAccount() {
    if (!this.current || !this.csrf || this.saving || !this.form.reportValidity()) return;
    const fingerprint=this.fingerprint();
    if (!this.requestIds.has(fingerprint)) this.requestIds.set(fingerprint,crypto.randomUUID());
    const payload={...this.payload(),id:this.requestIds.get(fingerprint)};
    this.saving=true;this.saveButton.disabled=true;this.saveStatus.textContent=this.tr('saving');
    try {
      const response=await fetch(this.apiUrl(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Readiness-CSRF':this.csrf},body:JSON.stringify(payload),signal:AbortSignal.timeout(15000)});
      const result=await response.json();
      if (!response.ok) { if(response.status===401||response.status===403)this.csrf=null; throw new Error(result.error || this.tr('save_failed')); }
      if(!result.assessment || !result.csrfToken)throw new Error(this.tr('save_failed'));
      this.csrf=result.csrfToken;this.savedFingerprint=fingerprint;
      await this.loadSaved();
      this.saveStatus.textContent=this.tr('saved_success',{date:payload.testDate});
    } catch(error) {
      this.saveStatus.textContent=this.csrf ? this.tr('save_failed') : this.tr('refresh_save_session');
    } finally {
      this.saving=false;this.saveButton.disabled=!this.current||!this.csrf||!this.form.checkValidity()||this.savedFingerprint===this.fingerprint();
    }
  }
  renderHistory() {
    this.historyArea.replaceChildren();
    for (const assessment of this.savedItems) {
      const card=document.createElement('details');card.className='ahc-lrs__history-card';
      const summary=document.createElement('summary');summary.textContent=this.tr('history_summary',{date:assessment.testDate,total:assessment.result.total,classification:this.classLabel(assessment.result.classification)});card.append(summary);
      const version=document.createElement('p');version.textContent=assessment.version+' · '+this.tr('self_tested');card.append(version);
      for (const event of EVENTS) { const line=document.createElement('p');line.textContent=this.tr('history_event',{event:this.tr(event.key),result:formatRaw(event.key,assessment[event.key]),points:assessment.result.events[event.key].points,max:event.max});card.append(line); }
      const conditions=document.createElement('p');conditions.textContent=[assessment.pullMethod,assessment.swimSetting,assessment.sprintTiming].join(' · ');card.append(conditions);
      if(assessment.notes){const notes=document.createElement('p');notes.textContent=assessment.notes;card.append(notes);}
      this.historyArea.append(card);
    }
  }
  export() {
    this.update();
    if (!this.current || !this.form.reportValidity()) return;
    const r=this.current;
    const headers=["Score name","Version","Test date","Athlete","Patrol / agency","Score type","Swim seconds","Sprint seconds","Run seconds","Carry seconds","Pull method","Pull reps","Swim setting","Sprint timing","Swim points","Sprint points","Run points","Carry points","Pull points","Total","Classification","Core physical benchmarks met","Notes","Disclaimer"];
    const values=["Lifeguard Readiness Score",VERSION,this.text("testDate"),this.text("athleteName"),this.text("patrol"),"Self Tested",this.raw.swim,this.raw.sprint,this.raw.run,this.raw.carry,this.raw.pullMethod,this.raw.pull,this.text("swimSetting"),this.text("sprintTiming"),...EVENTS.map(e=>r.events[e.key].points),r.total,r.classification === "Patrol Baseline" ? "Baseline" : r.classification,r.coreMet ? "Yes" : "No",this.text("notes"),"Physical preparation only. Lifeguarding also requires rescue skills, situational awareness, judgment, training, and experience. This score is not certification or a guarantee of rescue readiness."];
    const csv="\uFEFF"+[headers,values].map(row=>row.map(csvCell).join(",")).join("\r\n")+"\r\n";
    const url=URL.createObjectURL(new Blob([csv],{type:"text/csv;charset=utf-8;"}));
    const a=document.createElement("a"); a.href=url; a.download=`lifeguard-readiness-${this.text("testDate")}.csv`; this.append(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(url),30000);
    this.status.textContent=this.tr("downloaded");
  }
}
if (!customElements.get("ahc-readiness")) customElements.define("ahc-readiness",AHCReadiness);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
